import * as React from 'react';
import { useIntlUds } from '../../translations/UdsIntlProvider';
import StatusChip, { StatusChipType } from './StatusChip';

interface EnabledDisabledStatusChipProps {
  enabled?: boolean;
  deleted?: boolean;
}

export const EnabledDisabledStatusChip: React.FC<React.PropsWithChildren<EnabledDisabledStatusChipProps>> = ({
  enabled,
  deleted
}) => {
  const { intl } = useIntlUds();

  return (
    <StatusChip
      label={
        enabled
          ? intl.Chip.EnabledDisabledStatusChip.enabledLabel
          : deleted
            ? intl.Chip.EnabledDisabledStatusChip.deletedLabel
            : intl.Chip.EnabledDisabledStatusChip.disabledLabel
      }
      type={enabled ? StatusChipType.LIGHT_GREEN : deleted ? StatusChipType.LIGHT_RED : StatusChipType.GREY}
    />
  );
};
